var map = {
	"./amex-logo.png": 626,
	"./diners-logo.png": 772,
	"./discover-logo.png": 275,
	"./jcb-logo.png": 678,
	"./mastercard-logo.png": 313,
	"./unionpay-logo.png": 270,
	"./visa-logo.png": 503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;